import { ReactElement } from "react";
import clsx from "clsx";

import { Category } from "@/dto/category";
import { AppEventEmitter } from "@/components/appEventEmitter/appEventEmitter";
import { MenuItemProps, ProcessedItem } from "@/types/menus";
import { Layout } from "@/dto/item";
import { Markers } from "@/dto/marker";

interface MenuCategoryProps {
  readonly categoryId: Category["id"];
  readonly categoryName: Category["name"];
  readonly sortOrder?: Category["sortOrder"];
  readonly items: ProcessedItem[];
  readonly itemTemplate?: string;
  readonly merchantName?: string;
  readonly renderMenuItem: (props: MenuItemProps) => ReactElement<MenuItemProps>;
  readonly markers?: Markers;
  readonly layout?: Layout;
}

const MenuCategory = ({
  categoryId,
  categoryName,
  sortOrder,
  items,
  itemTemplate,
  merchantName,
  renderMenuItem,
  markers,
  layout = "default",
}: MenuCategoryProps) => {
  const headerId = `${categoryName.replaceAll(/\s+/g, "-")}-header`;

  return (
    <div
      key={categoryId}
      className="category"
      id={categoryName}
      data-sort-order={sortOrder}
    >
      <AppEventEmitter />
      <h2
        id={headerId}
        tabIndex={-1}
        className="mt-8 mb-5 font-medium text-[15px] text-[#5C5C5C]"
      >
        {String(categoryName).toUpperCase()}
      </h2>

      <ol
        className={clsx(
          "grid grid-cols-1 gap-x-8 gap-y-10 list-none xl:gap-x-8 justify-center",
          {
            "grid-cols-2 lg:grid-cols-4":
              itemTemplate?.toLowerCase() === "image focused",
            "grid-cols-1 lg:grid-cols-2":
              itemTemplate?.toLowerCase() === "description focused",
          }
        )}
      >
        {items.map(({ item, url, cartItem }) => (
          <li key={item.id}>
            {renderMenuItem({
              merchantName,
              itemTemplate,
              item,
              cartItem,
              url: url,
              categoryId: categoryId,
              markers,
              layout: layout,
            })}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default MenuCategory;
